import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API = '';

const TONES = [
  { value: 'formal', label: '격식체', desc: '정중한 비즈니스' },
  { value: 'friendly', label: '친근한', desc: '예의 바르지만 친근' },
  { value: 'casual', label: '편안한', desc: '가벼운 톤' },
  { value: 'urgent', label: '긴급', desc: '강조하는 톤' },
  { value: 'apologetic', label: '사과', desc: '정중한 사과' },
  { value: 'grateful', label: '감사', desc: '감사 표현' },
];

const TEMPLATES = [
  { label: '회의 요청', purpose: '회의 일정을 요청하는 이메일', points: '- 회의 주제\n- 희망 일시\n- 참석 요청' },
  { label: '업무 보고', purpose: '업무 진행 상황을 보고하는 이메일', points: '- 프로젝트명\n- 진행 현황\n- 이슈 사항\n- 향후 계획' },
  { label: '견적 요청', purpose: '제품/서비스 견적을 요청하는 이메일', points: '- 필요 제품/서비스\n- 수량/규모\n- 납기 희망일' },
  { label: '협조 요청', purpose: '타 부서에 협조를 요청하는 이메일', points: '- 요청 사항\n- 필요 사유\n- 기한' },
  { label: '일정 변경', purpose: '기존 일정 변경을 안내하는 이메일', points: '- 기존 일정\n- 변경 일정\n- 변경 사유' },
  { label: '감사 인사', purpose: '도움에 대한 감사 인사 이메일', points: '- 감사 대상\n- 구체적 도움 내용' },
];

function EmailAgent() {
  const navigate = useNavigate();
  const [mode, setMode] = useState('generate');
  const [purpose, setPurpose] = useState('');
  const [tone, setTone] = useState('formal');
  const [recipient, setRecipient] = useState('');
  const [sender, setSender] = useState('');
  const [keyPoints, setKeyPoints] = useState('');
  const [language, setLanguage] = useState('한국어');
  const [additional, setAdditional] = useState('');
  const [loading, setLoading] = useState(false);

  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');

  const [rewriteOriginal, setRewriteOriginal] = useState('');
  const [rewriteInstruction, setRewriteInstruction] = useState('');

  const [showSend, setShowSend] = useState(false);
  const [sendTo, setSendTo] = useState('');
  const [sendResult, setSendResult] = useState('');
  const [sending, setSending] = useState(false);

  const handleGenerate = async () => {
    if (!purpose.trim()) return alert('이메일 목적을 입력해주세요.');
    setLoading(true);
    try {
      const res = await fetch(`${API}/email/generate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ purpose, tone, recipient, sender, key_points: keyPoints, language, additional })
      });
      const data = await res.json();
      setSubject(data.subject || '');
      setBody(data.body || data.full || '');
    } catch (e) {
      setBody('생성 실패');
    }
    setLoading(false);
  };

  const handleRewrite = async () => {
    if (!rewriteOriginal.trim()) return alert('수정할 이메일을 입력해주세요.');
    setLoading(true);
    try {
      const res = await fetch(`${API}/email/rewrite`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ original: rewriteOriginal, instruction: rewriteInstruction })
      });
      const data = await res.json();
      setSubject(data.subject || '');
      setBody(data.body || data.full || '');
    } catch (e) {
      setBody('수정 실패');
    }
    setLoading(false);
  };

  const handleTemplate = (t) => {
    setPurpose(t.purpose);
    setKeyPoints(t.points);
  };

  const handleCopy = () => {
    const full = (subject ? '제목: ' + subject + '\n\n' : '') + body;
    navigator.clipboard.writeText(full);
    alert('복사되었습니다.');
  };

  const handleSendEmail = async () => {
    if (!sendTo.trim()) return alert('수신자 이메일을 입력해주세요.');
    setSending(true);
    setSendResult('');
    try {
      const res = await fetch(`${API}/email/send-generated`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ to: sendTo, subject, body })
      });
      const data = await res.json();
      setSendResult(data.error ? 'error:' + data.error : 'success:' + data.message);
    } catch (e) {
      setSendResult('error:전송 실패');
    }
    setSending(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa' }}>
      <div style={{
        background: 'linear-gradient(135deg, #c62828, #ef5350)',
        padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 16
      }}>
        <button onClick={() => navigate('/')}
          style={{
            background: 'rgba(255,255,255,0.15)', border: 'none', color: 'white',
            width: 36, height: 36, borderRadius: 8, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M12 4l-6 6 6 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <div>
          <div style={{ color: 'white', fontSize: 18, fontWeight: 'bold' }}>이메일 작성 에이전트</div>
          <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12 }}>CLSOFTLAB AI SERVICE</div>
        </div>
      </div>

      <div style={{ maxWidth: 900, margin: '24px auto', padding: '0 20px 40px' }}>
        {/* 모드 선택 */}
        <div style={{ display: 'flex', background: '#e0e0e0', borderRadius: 8, overflow: 'hidden', marginBottom: 20 }}>
          {[{v:'generate',l:'새 이메일 작성'},{v:'rewrite',l:'이메일 다듬기'}].map(m => (
            <button key={m.v} onClick={() => setMode(m.v)}
              style={{
                flex: 1, padding: '12px', border: 'none', cursor: 'pointer', fontSize: 14, fontWeight: 'bold',
                background: mode === m.v ? '#c62828' : 'transparent',
                color: mode === m.v ? 'white' : '#555',
              }}>{m.l}</button>
          ))}
        </div>

        {mode === 'generate' ? (
          <div style={{ display: 'grid', gridTemplateColumns: '280px 1fr', gap: 20 }}>
            {/* 왼쪽: 입력 */}
            <div>
              {/* 빠른 템플릿 */}
              <div style={{ background: 'white', borderRadius: 8, border: '1px solid #ddd', padding: 16, marginBottom: 16 }}>
                <h3 style={{ marginTop: 0, fontSize: 14, color: '#c62828' }}>빠른 템플릿</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  {TEMPLATES.map((t, i) => (
                    <button key={i} onClick={() => handleTemplate(t)}
                      style={{
                        padding: '8px 12px', background: '#fafafa', border: '1px solid #eee',
                        borderRadius: 6, cursor: 'pointer', textAlign: 'left', fontSize: 13
                      }}>{t.label}</button>
                  ))}
                </div>
              </div>

              {/* 설정 */}
              <div style={{ background: 'white', borderRadius: 8, border: '1px solid #ddd', padding: 16 }}>
                <h3 style={{ marginTop: 0, fontSize: 14, color: '#c62828' }}>설정</h3>
                <div style={{ marginBottom: 10 }}>
                  <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4 }}>톤</label>
                  <select value={tone} onChange={e => setTone(e.target.value)}
                    style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ddd', fontSize: 13 }}>
                    {TONES.map(t => <option key={t.value} value={t.value}>{t.label} - {t.desc}</option>)}
                  </select>
                </div>
                <div style={{ marginBottom: 10 }}>
                  <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4 }}>언어</label>
                  <select value={language} onChange={e => setLanguage(e.target.value)}
                    style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ddd', fontSize: 13 }}>
                    {['한국어','영어','일본어','중국어'].map(l => <option key={l} value={l}>{l}</option>)}
                  </select>
                </div>
                <div style={{ marginBottom: 10 }}>
                  <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4 }}>수신자 (이름/직함)</label>
                  <input type="text" value={recipient} onChange={e => setRecipient(e.target.value)}
                    placeholder="예: 김부장님" style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box' }} />
                </div>
                <div style={{ marginBottom: 10 }}>
                  <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4 }}>발신자 (이름/직함)</label>
                  <input type="text" value={sender} onChange={e => setSender(e.target.value)}
                    placeholder="예: 개발팀 이대리" style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box' }} />
                </div>
              </div>
            </div>

            {/* 오른쪽: 목적 + 결과 */}
            <div>
              <div style={{ background: 'white', borderRadius: 8, border: '1px solid #ddd', padding: 20, marginBottom: 16 }}>
                <div style={{ marginBottom: 12 }}>
                  <label style={{ fontSize: 13, fontWeight: 'bold', color: '#333', display: 'block', marginBottom: 6 }}>이메일 목적</label>
                  <input type="text" value={purpose} onChange={e => setPurpose(e.target.value)}
                    placeholder="예: 다음 주 월요일 프로젝트 킥오프 미팅 요청"
                    style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 15, boxSizing: 'border-box' }} />
                </div>
                <div style={{ marginBottom: 12 }}>
                  <label style={{ fontSize: 13, fontWeight: 'bold', color: '#333', display: 'block', marginBottom: 6 }}>포함할 핵심 내용</label>
                  <textarea value={keyPoints} onChange={e => setKeyPoints(e.target.value)}
                    placeholder="- 포함할 내용을 줄별로 입력&#10;- 구체적일수록 좋은 결과"
                    style={{ width: '100%', minHeight: 80, padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 14, boxSizing: 'border-box', fontFamily: 'inherit' }} />
                </div>
                <div style={{ marginBottom: 12 }}>
                  <label style={{ fontSize: 13, fontWeight: 'bold', color: '#333', display: 'block', marginBottom: 6 }}>추가 요청 (선택)</label>
                  <input type="text" value={additional} onChange={e => setAdditional(e.target.value)}
                    placeholder="예: 간결하게, 3문장 이내로"
                    style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 14, boxSizing: 'border-box' }} />
                </div>
                <button onClick={handleGenerate} disabled={loading}
                  style={{
                    padding: '10px 28px', background: loading ? '#ccc' : '#c62828', color: 'white',
                    border: 'none', borderRadius: 6, cursor: loading ? 'not-allowed' : 'pointer',
                    fontSize: 15, fontWeight: 'bold'
                  }}>{loading ? '작성중...' : '이메일 생성'}</button>
              </div>

              {/* 결과 */}
              {body && (
                <div style={{ background: 'white', borderRadius: 8, border: '1px solid #ddd', overflow: 'hidden' }}>
                  <div style={{ padding: '12px 20px', background: '#fafafa', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontWeight: 'bold', color: '#333', fontSize: 14 }}>생성된 이메일</span>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button onClick={handleCopy}
                        style={{ padding: '5px 12px', background: '#666', color: 'white', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12, fontWeight: 'bold' }}>복사</button>
                      <button onClick={() => setShowSend(true)}
                        style={{ padding: '5px 12px', background: '#c62828', color: 'white', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12, fontWeight: 'bold' }}>바로 전송</button>
                    </div>
                  </div>
                  {subject && (
                    <div style={{ padding: '12px 20px', background: '#fff8f8', borderBottom: '1px solid #eee' }}>
                      <span style={{ fontSize: 12, color: '#999' }}>제목</span>
                      <div style={{ fontSize: 15, fontWeight: 'bold', color: '#333', marginTop: 2 }}>{subject}</div>
                    </div>
                  )}
                  <div style={{ padding: 20, fontSize: 15, lineHeight: 1.8, whiteSpace: 'pre-wrap', color: '#333' }}>
                    {body}
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          /* 다듬기 모드 */
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
            <div style={{ background: 'white', borderRadius: 8, border: '1px solid #ddd', overflow: 'hidden' }}>
              <div style={{ padding: '12px 16px', background: '#fafafa', borderBottom: '1px solid #eee', fontSize: 13, fontWeight: 'bold', color: '#888' }}>원본 이메일</div>
              <textarea value={rewriteOriginal} onChange={e => setRewriteOriginal(e.target.value)}
                placeholder="다듬고 싶은 이메일을 붙여넣기 하세요..."
                style={{ width: '100%', minHeight: 300, padding: 16, border: 'none', outline: 'none', fontSize: 14, lineHeight: 1.7, boxSizing: 'border-box', fontFamily: 'inherit', resize: 'vertical' }} />
              <div style={{ padding: '12px 16px', borderTop: '1px solid #eee' }}>
                <input type="text" value={rewriteInstruction} onChange={e => setRewriteInstruction(e.target.value)}
                  placeholder="수정 요청 (예: 더 격식체로, 영어로 변환, 간결하게)"
                  style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box', marginBottom: 8 }} />
                <button onClick={handleRewrite} disabled={loading}
                  style={{
                    padding: '8px 20px', background: loading ? '#ccc' : '#c62828', color: 'white',
                    border: 'none', borderRadius: 6, cursor: loading ? 'not-allowed' : 'pointer',
                    fontSize: 14, fontWeight: 'bold'
                  }}>{loading ? '수정중...' : '이메일 다듬기'}</button>
              </div>
            </div>
            <div style={{ background: 'white', borderRadius: 8, border: '1px solid #ddd', overflow: 'hidden' }}>
              <div style={{ padding: '12px 16px', background: '#fafafa', borderBottom: '1px solid #eee', fontSize: 13, fontWeight: 'bold', color: '#888', display: 'flex', justifyContent: 'space-between' }}>
                <span>수정된 이메일</span>
                {body && (
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button onClick={handleCopy}
                      style={{ padding: '4px 10px', background: '#666', color: 'white', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 11 }}>복사</button>
                    <button onClick={() => setShowSend(true)}
                      style={{ padding: '4px 10px', background: '#c62828', color: 'white', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 11 }}>전송</button>
                  </div>
                )}
              </div>
              {subject && (
                <div style={{ padding: '12px 16px', background: '#fff8f8', borderBottom: '1px solid #eee' }}>
                  <span style={{ fontSize: 12, color: '#999' }}>제목</span>
                  <div style={{ fontSize: 15, fontWeight: 'bold', marginTop: 2 }}>{subject}</div>
                </div>
              )}
              <div style={{ padding: 16, minHeight: 300, fontSize: 14, lineHeight: 1.8, whiteSpace: 'pre-wrap', color: body ? '#333' : '#ccc' }}>
                {body || '수정된 이메일이 여기에 표시됩니다.'}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* 전송 모달 */}
      {showSend && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
        }} onClick={e => { if (e.target === e.currentTarget) setShowSend(false); }}>
          <div style={{ background: 'white', borderRadius: 12, width: '90%', maxWidth: 480, overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ background: 'linear-gradient(135deg, #c62828, #ef5350)', padding: '20px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: 'white', fontSize: 18, fontWeight: 'bold' }}>이메일 전송</span>
              <button onClick={() => setShowSend(false)}
                style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: 'white', width: 30, height: 30, borderRadius: '50%', cursor: 'pointer', fontSize: 16 }}>X</button>
            </div>
            <div style={{ padding: 24 }}>
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 13, fontWeight: 'bold', display: 'block', marginBottom: 4 }}>받는 사람</label>
                <input type="text" value={sendTo} onChange={e => setSendTo(e.target.value)}
                  placeholder="example@email.com"
                  style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ddd', fontSize: 14, boxSizing: 'border-box' }} />
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 13, fontWeight: 'bold', display: 'block', marginBottom: 4 }}>제목</label>
                <input type="text" value={subject} onChange={e => setSubject(e.target.value)}
                  style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ddd', fontSize: 14, boxSizing: 'border-box' }} />
              </div>
              <div style={{ background: '#f8f9fa', borderRadius: 6, padding: 12, marginBottom: 16, maxHeight: 120, overflowY: 'auto', fontSize: 13, whiteSpace: 'pre-wrap', color: '#555', border: '1px solid #eee' }}>
                {body.substring(0, 300)}{body.length > 300 ? '...' : ''}
              </div>
              {sendResult && (
                <div style={{
                  padding: 10, borderRadius: 6, marginBottom: 12, fontSize: 13,
                  background: sendResult.startsWith('success') ? '#e8f5e9' : '#ffebee',
                  color: sendResult.startsWith('success') ? '#2e7d32' : '#c62828',
                }}>{sendResult.split(':').slice(1).join(':')}</div>
              )}
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                <button onClick={() => setShowSend(false)}
                  style={{ padding: '10px 20px', background: '#f1f3f4', color: '#333', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>취소</button>
                <button onClick={handleSendEmail} disabled={sending}
                  style={{ padding: '10px 24px', background: sending ? '#ccc' : '#c62828', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14, fontWeight: 'bold' }}>
                  {sending ? '전송중...' : '전송'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default EmailAgent;
